<template>
  <div>
    <div class="bg-theme-green border-0 rounded-t-xl px-4 py-2 text-white">
      <div class="flex justify-between items-center">
        <h2 class="font-semibold leading-tight truncate text-single-line break-all text-2xl mt-0">{{ form.first_name.value ? form.first_name.value : 'New Customer' }}
        </h2>
        <div class="flex flex-col">
          <div class="flex justify-end items-center">
            <button @click.prevent="addNew()" class="cursor-pointer rounded-md bg-white text-theme-green py-2 px-3 hover:bg-theme-darkgreen hover:text-white mr-3">
              SAVE 
            </button>
            <span @click.prevent="clearComponent" class="cursor-pointer rounded-md  text-white py-2 pl-1  hover:opacity-70">CLOSE</span>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg">
      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.first_name.error_type)">
            <label class="text-xs mb-1">First Name</label>
            <input v-model="form.first_name.value" @keyup="validateFields(['first_name'])" placeholder="First Name" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
            <p class="field-error label-text mt-1" v-if="form.first_name.error_message" v-text="form.first_name.error_message"></p>
          </div>
        </div>

        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.last_name.error_type)">
            <label class="text-xs mb-1">Last Name</label>
            <input v-model="form.last_name.value" @keyup="validateFields(['last_name'])" placeholder="Last Name" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
            <p class="field-error label-text mt-1" v-if="form.last_name.error_message" v-text="form.last_name.error_message"></p>
          </div>
        </div>
      </div>

      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.email.error_type)">
            <label class="text-xs mb-1">Email</label>
            <input v-model="form.email.value" @keyup="validateFields(['email'])" placeholder="Email" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
            <p class="field-error label-text mt-1" v-if="form.email.error_message" v-text="form.email.error_message"></p>
          </div>
        </div>

        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.phone.error_type)">
            <label class="text-xs mb-1">Phone Number</label>
            <input v-model.number="form.phone.value" :onkeypress="preventNonNumbers" @keyup="validateFields(['phone'])" placeholder="Phone Number" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="number">
            <p class="field-error label-text mt-1" v-if="form.phone.error_message" v-text="form.phone.error_message"></p>
          </div>
        </div>
      </div>

      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.birthday.error_type)">
            <label class="text-xs mb-1">Birthday</label>
            <div class=" bg-gray-black rounded w-full flex items-center">
              <span class="ml-2 mr-2">
                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3C0 2.6 0.15 2.25 0.45 1.95C0.75 1.65 1.1 1.5 1.5 1.5H3.125V0H4.75V1.5H13.25V0H14.875V1.5H16.5C16.9 1.5 17.25 1.65 17.55 1.95C17.85 2.25 18 2.6 18 3V18.5C18 18.9 17.85 19.25 17.55 19.55C17.25 19.85 16.9 20 16.5 20H1.5ZM1.5 18.5H16.5V7.75H1.5V18.5ZM1.5 6.25H16.5V3H1.5V6.25ZM1.5 6.25V3V6.25Z" fill="white" />
                </svg>
              </span>
              <Datepicker v-model="form.birthday.value" placeholder="Select a Date" class="text-sm focus:border-transparent focus:ring-0 bg-gray-black border-0 w-full" />
            </div>
            <p class="field-error label-text mt-1" v-if="form.birthday.error_message" v-text="form.birthday.error_message"></p>
          </div>
        </div>

        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.startingPoint.error_type)">
            <label class="text-xs mb-1">Starting Point Amount</label>
            <input v-model="form.startingPoint.value" :onkeypress="preventNonNumbers" @keyup="validateFields(['startingPoint'])" placeholder="Starting Point Amount" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="number">
            <p class="field-error label-text mt-1" v-if="form.startingPoint.error_message" v-text="form.startingPoint.error_message"></p>
          </div>
        </div>
      </div>

    
    </div>
  </div>
</template>
<script lang="ts">
  import { defineComponent, ref} from "vue"
  import {mapGetters,mapActions,mapMutations} from "vuex";
  import BusinessCategoryApis from "@/controllers/BusinessCategoryApis";
  import { useSnackbar} from "vue3-snackbar";
  import Datepicker from 'vue3-datepicker'
  import Helpers from '@/helpers';
  export default defineComponent({
    name: "MembershipCustomerAdd",
    components: {
      Datepicker,
    },
    props: {
      clearComponent: {
        type: Function,
        required: true,
      },
    },
    setup() {
      const snackbar = useSnackbar();
      const form = < any > ref({
        businessId: '',
        first_name: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'min:3'],
        },
        last_name: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'min:3'],
        },
        email: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'email'],
        },
        phone: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['mustbe:10'],
        },
        birthday: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required'],
        },
        startingPoint: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required_min_0'],
        },
      })
      return {
        snackbar,
        form,
      };
    },
    computed: {
      ...mapGetters({
        vg_activeBusiness: 'auth/activeBusiness',
      }),
    },
    async mounted() {},
    methods: {
      /**
       * Validation captures
       */
      async validateFields(fields) {
        let res = await Helpers.validateFormFields(this.form, fields);
        // capture the fields
        this.form = res.data;
        return res.error ? false : true;
      },
      async addNew() {
        // validate business field
        let validate = await this.validateFields(['first_name', 'last_name', 'email', 'phone', 'birthday', 'startingPoint']);
        if (!validate) {
          return;
        }
        this.form.businessId = this.vg_activeBusiness.id;
        let data = < any > Helpers.getFormKeyValue(this.form);
        this.va_spinner(true);
        // let res = await BusinessCategoryApis.addNew(data);  
        // this.va_spinner(false);
        // this.snackbar.add({
        //   type: 'info',
        //   text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        //   duration: 3000,
        // })
        // if(res.status == 201) {
        //   this.clearComponent()
        //    this.emitter.emit("refresh-product-reasoncode-list", true);
        // }
      },
      /**
       * Do not allow to add +,-,e
       */
      preventNonNumbers(e) {
        var ASCIICode = (e.which) ? e.which : e.keyCode
        if (ASCIICode == 43 || ASCIICode == 45 || ASCIICode == 101) {
          return false;
        }
        return true;
      },
      ...mapActions({
        va_spinner: 'spinner/setSpinner',
      })
    },
  });
</script>